module.exports = __webpack_public_path__ + "static/media/computer2.345c5653.svg";